import React from "react"
import type { ReactNode } from "react"
import cx from "classnames"
import { AvatarSize } from "./types"

const getBackgroundColor = (name?: string) => {
  if (!name?.trim()) return "bg-gray-300 text-black-700"

  const colors = [
    "bg-blue-700 text-white",
    "bg-green-700 text-white",
    "bg-purple-700 text-white",
    "bg-orange-700 text-white"
  ]

  // Generate a hash from the name to ensure consistent color
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = (hash << 5) - hash + name.charCodeAt(i)
    hash = hash & hash // Convert to 32-bit integer
  }

  return colors[Math.abs(hash) % colors.length]
}

type AvatarFallbackProps = {
  children: ReactNode
  name?: string
  className?: string
  size?: AvatarSize
}

const AvatarFallback = ({
  children,
  name,
  className,
  size = "sm"
}: AvatarFallbackProps) => {
  const SIZE_CLASSES = {
    sm: "w-6 h-6",
    lg: "w-10 h-10"
  }
  const FONT_SIZE = {
    sm: "0.625rem",
    lg: "0.875rem"
  }
  const colors = getBackgroundColor(name)

  return (
    <div
      className={cx(
        SIZE_CLASSES[size],
        "rounded-full flex items-center justify-center overflow-hidden leading-none",
        colors,
        "font-semibold",
        className
      )}
      style={{ fontSize: FONT_SIZE[size] }}
    >
      {children}
    </div>
  )
}

export default AvatarFallback
